import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Notification } from '@qure/containers'

const SimpleLoader = props => {
  const { label } = props
  return (
    <Notification isLight color="info">
      <Icon iConClass="fa-spinner" isAnimated />
      {label}
    </Notification>
  )
}

SimpleLoader.defaultProps = {
  label: 'Loading the data'
}

SimpleLoader.propTypes = {
  label: PropTypes.string
}

export default SimpleLoader
